import './../../../styles/templates/register.scss';

(function(){
  const $form = $(".create-customer-form");
  const $marketingConsent = $("[data-marketing-consent]");
  const $profilingConsent = $("[data-profiling-consent]");
  const $marketingConsentInput = $marketingConsent.find(
    'input[type="checkbox"]',
  );
  const $profilingConsentInput = $profilingConsent.find(
    'input[type="checkbox"]',
  );
  const $customerTagsInput = $('input[name="customer[tags]"]');

  const inputIsSelected = function ($input) {
    return $input.is(":checked");
  };

  const triggerProfilingConsent = function (checked) {
    $profilingConsentInput
      .prop("checked", checked ? "checked" : checked)
      .trigger("change");
  };

  $form.on("submit", () => {
    if ($customerTagsInput.length) {
      const tagsValues = [];
      const profiling = inputIsSelected($profilingConsentInput);
      if (profiling) {
        tagsValues.push("PROFILING__TRUE");
      }
      const gender = document.querySelector(
        'input[name="customer[gender]"]:checked',
      )?.value;

      if (gender) {
        tagsValues.push(`GENDER__${gender.toUpperCase()}`);
      }

      $customerTagsInput.val(tagsValues.join(","));
    }
  });

  if (
    $marketingConsent.length &&
    $profilingConsent.length &&
    $marketingConsentInput.length &&
    $profilingConsentInput.length
  ) {
    $marketingConsentInput.on("change", function () {
      const $currentInput = $(this);

      if (inputIsSelected($currentInput)) {
        $profilingConsent.removeClass("transparent");
      } else {
        $profilingConsent.addClass("transparent");
        triggerProfilingConsent(false);
      }
    });
  }
})();
